import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { DataService } from 'src/app/shared/services/data.service';
import { PerformanceConstantsService } from './performance-constants.service';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  public currentStatisticPageIndex: number;
  sendLeaderData = new Subject();
  public updateSourceActionData: any;

  constructor(private dataService: DataService, private baseService: BaseService) { }
  public setSourceActionData(data) {
    this.updateSourceActionData = data;
  }
  public getSourceActionData() {
    return this.updateSourceActionData;
  }
  getLeaderPersonalData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetLeaderPersonalData, model).subscribe(
      response => callbackMethod(response.Result)
    );
  }

  getLeaderProcessData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetLeaderProcessData, model).subscribe(
      response => callbackMethod(response.Result)
    );
  }

  getActionTrackerData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetActionTrackerData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getPDSelectedDetails(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetPDSelectedDetails, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getContractDetailsData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetContractDetailsData, model).subscribe(
      response => callbackMethod(response.Result)
    );
  }

  saveContractorStat(model, callbackMethod){
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.SaveContractorStat, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getSafetyObservationData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetSafetyObservationData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getWasteGenerationData(model, callbackMethod){
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetWasteGenerationData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getStatisticStatus(model, callbackMethod){
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetStatisticStatus, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getStatisticRequests(model, callbackMethod){
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetStatisticRequests, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getAllCheckedStatisticRequestIds() {
    return JSON.parse(this.baseService.getItemFromSession('StatisticIds'));
  }

  public setAllCheckedStatisticRequestIds(allStatisticData) {
    let StatisticIds = [];
    allStatisticData.forEach(item => {
      StatisticIds.push({ 'statisticId': item.statisticId, 'unitId': item.unitId });
    });
    this.baseService.setItemInSession('StatisticIds', JSON.stringify(StatisticIds));
  }

  getAllStatisticRequestIds() {
    return JSON.parse(this.baseService.getItemFromSession('allStatisticIds'));
  }

  public setAllStatisticRequestIds(allStatisticData) {
    let StatisticIds = [];
    allStatisticData.forEach(item => {
      StatisticIds.push({ 'statisticId': item.statisticId});
    });
    this.baseService.setItemInSession('allStatisticIds', JSON.stringify(StatisticIds));
  }

  setcurrentStatisticPageIndex(pageId) {
    this.currentStatisticPageIndex = pageId;
  }

  getEnergyConsumptionData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetEnergyConsumptionData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  exportToExcelStatistics(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.ExportToExcel, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getStatisticRequestByStatisticId(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetStatisticRequestByStatisticId, model).subscribe(
      response => callbackMethod(response)
    );
  }

  saveContraStatApproval(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.SaveContraStatApproval, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getObservationTypeData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetObservationTypeData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getKPIData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetKPIData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getActionPriorityData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetActionPriorityData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getIncidentHighPotentialData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetIncidentHighPotentialData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getIncidentTypeData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetIncidentTypeData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  //BOC Pritesh
  getInspectionTypeData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetInspectionTypeData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getObservationCategoryData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetObservationCategoryData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getIncidentCategoryData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetIncidentCategoryData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTrainingStatusData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetTrainingStatusData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getTrainingComplianceData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetTrainingComplianceData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTrainingComplianceSummaryData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetTrainingComplianceSummaryData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getIncidentRegisterData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetIncidentRegisterData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getEnergyWasteConsumptionData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetEnergyWasteConsumptionData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getEnergyWasteConsumptionUnitWiseData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetEnergyWasteConsumptionUnitWiseData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getPOBRosterData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetPOBRosterData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getPOBRosterMonthwiseData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetPOBRosterMonthwiseData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  //EOC Pritesh

  getObservationByObserverData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetObservationByObserverData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getObservationActionData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetObservationActionData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getManHourCalculationData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetManHourCalculationData, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getHeadCountData(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetHeadCountData, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getKPIDetails(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetKPIDetails, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getKPITargetsByYear(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.GetKPITargetsByYear, model).subscribe(
      response => callbackMethod(response)
    );
  }

  saveOrUpdateKPITargets(model, callbackMethod) {
    return this.dataService.post(PerformanceConstantsService.PerformanceURL.SaveOrUpdateKPITargets, model).subscribe(
      response => callbackMethod(response)
    );
  }

  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(PerformanceConstantsService.PerformanceURL.DownloadZip, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(PerformanceConstantsService.PerformanceURL.downloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
